<div class="list-component-wrapper">
  <div class="list-component-header" [hidden]="isLoading">
    <div class="row">
      <div class="container">
        <input type="text" placeholder="Search Brokers" class="form-control search-box" [(ngModel)]="searchText" />
        <button class="btn btn-primary text-white" (click)="open()">
          <i class="material-icons">add</i> <span>Create Brokers</span>
        </button>
      </div>
    </div>
  </div>
  <div [hidden]="brokerList.length !== 0 || isLoading === true" class="no-result-wrapper">
    <h5>No Broker found!</h5>
  </div>

  <div class="row">
    <div class="container">
      <div class="list-component-body">
        <table>
          <thead [hidden]="brokerList.length === 0">
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Last Logged In</th>
              <th>Email Sent On</th>
              <th>SMS Sent On</th>
              <th>Created On</th>
              <th><div class="float-right">Action</div></th>
            </tr>
          </thead>
          <tbody>
            <tr [hidden]="!isLoading">
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer primary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper float-right">
                  <div class="shimmer tertiary"></div>
                </div>
              </td>
            </tr>
            <tr [hidden]="!isLoading">
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer primary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper">
                  <div class="shimmer secondary"></div>
                </div>
              </td>
              <td>
                <div class="shimmer-wrapper float-right">
                  <div class="shimmer tertiary"></div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody
            *ngIf="brokerList | searchFilter: searchText:brokerProperty as result"
            [hidden]="isLoading || brokerList.length === 0"
          >
            <tr *ngFor="let broker of result | slice: (page - 1) * pageSize:(page - 1) * pageSize + pageSize">
              <td>{{ broker.code }}</td>
              <td>{{ broker.name }}</td>
              <td>{{ broker.email }}</td>
              <td>{{ broker.mobileNo }}</td>
              <td><app-date-shared [date]="broker.lastLoggedInAt"> </app-date-shared></td>
              <td><app-date-shared [date]="broker.loginEmailSentAt"> </app-date-shared></td>
              <td><app-date-shared [date]="broker.loginSMSSentAt"> </app-date-shared></td>
              <td><app-date-shared [date]="broker.createdAt"> </app-date-shared></td>
              <td>
                <div class="position-relative">
                  <button
                    type="button"
                    class="btn btn-link float-right dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="material-icons">more_vert</i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item" (click)="edit(broker)">Edit</button>
                    <button
                      class="dropdown-item"
                      (click)="shareCredentials(broker)"
                      [disabled]="broker.isLoginDetailsSent"
                    >
                      Share Credentials
                    </button>
                    <button class="dropdown-item" (click)="removeBroker(broker.id)">Remove</button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="8" class="border-0 p-0">
                <div class="pagination-wrapper">
                  <ngb-pagination
                    [collectionSize]="result.length"
                    [pageSize]="pageSize"
                    [(page)]="page"
                    [boundaryLinks]="true"
                    [maxSize]="3"
                    [rotate]="true"
                    [hidden]="result.length === 0 || isLoading"
                  ></ngb-pagination>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
